import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type RecruitingHiringCriteriaCategoryFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  status: defaultStatus,
} as RecruitingHiringCriteriaCategoryFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/recruiting-hiring-criteria-categories', name: 'Hiring Criteria Categories' },
];
